require('codemirror/mode/sparql/sparql');

module.exports = {
	options: {
		mode: 'application/sparql-query',
		lineNumbers: true,
		smartIndent: false
	}
};
